import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {FormBuilder} from "@angular/forms";
import {Subscription} from "rxjs";
import {Pending} from "../../../../shared/decorators/pending.decorator";
import {DisposeMixin} from "../../../../shared/mixins/dispose.mixin";
import {LockMixin} from "../../../../shared/mixins/lock.mixin";
import {EmptyMixin} from "../../../../shared/mixins/empty.mixin";
import {NotificationService} from "../../../../shared/services/components/notification.service";
import {LotNumberRequestForm} from "../../../forms/lot-number-request.form";
import {LotNumberRequestModel} from "../../../models/cofa-widget/lot-number-request.model";
import {LotNumberResultItemModel} from "../../../models/cofa-widget/lot-number-result-item.model";
import {CofaWidgetService} from "../../../services/cofa-widget.service";
import {LotNumberService} from "../../../services/lot-number.service";
import {ConfigurationService} from "../../../../shared/services/configuration.service";
import {CofaWidgetConfigModel} from "../../../models/cofa-widget/cofa-widget-config.model";

@Component({
    selector: "pcg-ng-lot-number-request-panel",
    template: require('./lot-number-request-panel.component.html')
})
export class LotNumberRequestPanelComponent extends DisposeMixin(LockMixin(EmptyMixin)) implements OnInit, OnChanges, OnDestroy {
    private submitSubscription: Subscription;

    @Pending
    private requestSubscription: Subscription;

    public requestForm: LotNumberRequestForm;

    @Input()
    public lotNumber: string;

    public constructor(
        private configService: ConfigurationService<CofaWidgetConfigModel>,
        private formBuilder: FormBuilder,
        private requestService: LotNumberService,
        private notificationService: NotificationService,
        private cofaWidgetService: CofaWidgetService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.requestForm = LotNumberRequestForm.createForm(
            this.formBuilder,
            new LotNumberRequestModel(this.lotNumber)
        );

        this.submitSubscription = this.requestForm.submitObservable
            .subscribe((request: LotNumberRequestModel) => this.requestLotNumber(request));
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const lotNumber = changes.lotNumber.currentValue as string;
        if(lotNumber && this.requestForm) {
             if(lotNumber !== this.requestForm.lotNumber.value) {
                 this.requestForm.lotNumber.setValue(lotNumber);
             }
        }
    }

    public ngOnDestroy(): void {
        this.dispose();
    }

    public handleRequestClick(): void {
        this.requestForm.submit();
    }

    public handleBackToSearchClick(): void {
        this.cofaWidgetService.setSearchMode();
    }

    private requestLotNumber(request: LotNumberRequestModel): void {
        request.vcpId = this.configService.config.vcpId;
        this.requestSubscription = this.requestService.requestLotNumber(request)
            .subscribe(
                (result: LotNumberResultItemModel) => {
                    this.notificationService.showSuccess("Thank you for submitting the form.", "We will email you with the relevant certificate of analysis.");
                    this.cofaWidgetService.setSearchMode();
                });
    }
}
